var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.38098 0.66383L6.25748 4.61111C6.23334 4.65701 6.19799 4.69611 6.15574 4.72671C6.1135 4.75731 6.06435 4.7777 6.01262 4.7862L1.54836 5.55798C1.08624 5.63788 0.706892 5.96257 0.562049 6.40201C0.417206 6.84144 0.530149 7.32423 0.856908 7.65657L4.00896 10.8678C4.04518 10.9052 4.07276 10.9502 4.08915 10.9987C4.10553 11.048 4.10984 11.0998 4.10294 11.1517L3.46753 15.5758C3.402 16.0331 3.59771 16.4895 3.97706 16.7615C4.35641 17.0335 4.85647 17.076 5.27806 16.8728L9.34918 14.9094C9.3966 14.8864 9.44833 14.8754 9.50092 14.8754V0C9.03105 0 8.60083 0.255842 8.38098 0.66383Z",
    fill: "#16C098"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9912 10.8676L18.1432 7.65622C18.4691 7.32385 18.5829 6.84104 18.4381 6.40157C18.2933 5.96211 17.9139 5.6374 17.4518 5.55749L12.9875 4.78652C12.9357 4.77717 12.8866 4.75677 12.8444 4.72701C12.8021 4.69641 12.7668 4.65731 12.7426 4.61141L10.6191 0.663023C10.3992 0.255859 9.96902 0 9.5 0V14.8755C9.55259 14.8755 9.60432 14.8874 9.65174 14.9095L13.7229 16.8731C14.1445 17.0762 14.6446 17.0329 15.0239 16.7617C15.4033 16.4897 15.599 16.0341 15.5335 15.5759L14.898 11.1515C14.8903 11.1005 14.8955 11.0478 14.9118 10.9985C14.9274 10.9501 14.9549 10.905 14.9912 10.8676Z",
    fill: "#16C098"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.9658984296e0d737eef7ac780b6cfccb.svg";
export { ForwardRef as ReactComponent };